import React from "react";
import { Intro, Naviation } from ".";

const Header =  props => (
    <div>
        <Intro about={props.refs[1]} />
        <Naviation home={props.refs[0]} about={props.refs[1]} skills={props.refs[2]} portfolio={props.refs[3]} contact={props.refs[4]} />
    </div>
);

export default Header;


// WEBPACK FOOTER //
// ./src/Components/header.jsx